<template>
  <div>
    <div class="lightPoint">
      <!--<div class="lightPoint-cont">
        <mt-swipe :auto="400000">
          <mt-swipe-item v-for="(item, index) in imgList" :key="index">
            <div class="img-box">
              <img :src="item.img" alt="" />
            </div>
          </mt-swipe-item>
        </mt-swipe>
      </div>-->
      <div id="station">
          <div class="line">
              <div :class="'normal '+ currentArea">
                <div class="common-lf common"></div>
                <div class="common-active common">
                    
                </div>
                <div class="common-rt common"></div>
                <div :class="'carBox '+'carBox_'+currentArea">
                  <img class="car" src="https://picbed.qunarzz.com/c47bb9b4103aadb78f16df9d6f9e4515.png" alt="">
                  <div class="car-txt">
                    <img src="https://picbed.qunarzz.com/a3e6dcad5fb5845bc82c6dbbf3c9219a.png" alt="">
                    <span class="txt">{{textMap[currentArea]}}</span>
                  </div>
                </div>
                <div @click="setCurrent(item)" v-for="(item,index) in areaList" :key="index" :class="'area area_'+item"></div>
              </div>
          </div>
          <!--<videoComp></videoComp>-->
          <div class="imgBg"> 
            <video-comp :poster="areaMap[currentArea].img" :src="areaMap[currentArea].video"></video-comp>
          </div>
          <div class="desBg">
              <img v-if="!areaMap[currentArea].href" :src="areaMap[currentArea].des" alt="">
              <a v-else :href="areaMap[currentArea].href"><img :src="areaMap[currentArea].des" alt=""></a>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import swiperComp from './swiper.vue'
import videoComp from './video.vue'
export default {
  components:{
      swiperComp,
      videoComp
  },
  data() {
    return {
      currentArea:'cd',
      areaList:[
        'ls',
        'blc',
        'lz',
        'bm',
        'bs',
        'cd'
      ],
      areaMap:{
        'ls':{
          img:'https://picbed.qunarzz.com/e965a9b543f445f3d567ac24482afb92.png',
          video:'https://picbed.qunarzz.com/3c926215db390994ef5fd1ddee1be112.MP4',
          href:'http://travel.qunar.com/travelbook/note/7694997',
          des:'https://picbed.qunarzz.com/9ecfd8d34e57f7c780b9e732ed4ce5c1.png'
        },
        'blc':{
          img:'https://picbed.qunarzz.com/8336471a9be2974fccdc7f6bc08b3abf.png',
          video:'https://picbed.qunarzz.com/7e3013b0382faf28d1aa80e00451db28.MP4',
          des:'https://picbed.qunarzz.com/969bfea513548accd442b66049a3c070.png',
          href:'https://travel.qunar.com/travelbook/note/7694684',
        },
        'lz':{
          img:'https://picbed.qunarzz.com/8ddb2a1bff7c85680767e5943dfee5ac.png',
          video:'https://picbed.qunarzz.com/c4e4c4e63e84e073b3a27e8ea7b3170e.mp4',
          des:'https://picbed.qunarzz.com/053d4d295a43e189b937133a0e95c605.png',
          href:'https://travel.qunar.com/travelbook/note/7694147'
        },
        'bm':{
          img:'https://picbed.qunarzz.com/1c942830f15167cdd48b5e87c9ff223b.png',
          video:'https://picbed.qunarzz.com/f27fed8356158f050b40c7f7b40006a9.mp4',
          href:'https://touch.travel.qunar.com/youji/7691950?bd_source=RN&showType=share',
          des:'https://picbed.qunarzz.com/7399ae2eb99430bca49243471ff4e84e.png'
        },
        'bs':{
          video:'https://picbed.qunarzz.com/40c022e8df6628a129c7cb5e1a8b1c06.mp4',
          img:'https://picbed.qunarzz.com/e34c1bfd8a57b5601ba93be70c125ed4.png',
          href:'http://travel.qunar.com/travelbook/note/7693807',
          des:'https://picbed.qunarzz.com/c527c27f25e2ee550f04ed556da1410c.png'
        },
        'cd':{
          img:'https://picbed.qunarzz.com/d6ac166c9a65218d14dbda1eb4ac5c35.png',
          video:'https://picbed.qunarzz.com/3dece97f29ead4ee39cdbf811cf2002c.mp4',
          href:'https://travel.qunar.com/travelbook/note/7692453',
          des:'https://picbed.qunarzz.com/be577dd941b8d3725e4ef0db5eb02d35.png'
        }
      },
      textMap:{
        'ls':'第六站 拉萨',
        'blc':'第五站 巴松措',
        'lz':'第四站 林芝',
        'bm':'第三站 波密',
        'bs':'第二站 八宿',
        'cd':'第一站 昌都'
      },
      imgList: [
        {
          img:
            "https://picbed.qunarzz.com/36f21d7fb6a72839ba3027307efe8417.jpeg",
          title: "ProPILOT超智驾 L2级自动驾驶辅助系统",
        },
        {
          img:
            "https://picbed.qunarzz.com/57da22dad8b3d4db114632390049594d.jpeg",
          title: "动感光绘外观设计",
        },
        {
          img:
            "https://picbed.qunarzz.com/0a6898277de1604a8de9759eba446281.jpg",
          title: "灵活多变乘坐空间",
        },

        {
          img:
            "https://picbed.qunarzz.com/146730e4dcc113c781d5b66b143859eb.jpeg",
          title: "ProPILOT超智驾 L2级自动驾驶辅助系统",
        },
        {
          img:
            "https://picbed.qunarzz.com/2187b13cee1563ca5e8dd1ad315b846c.jpeg",
          title: "ProPILOT超智驾 L2级自动驾驶辅助系统",
        },
      ],
    };
  },
  methods:{
    setCurrent(item){
      this.currentArea = item;
    }
  }
};
</script>
<style lang='less' scoped='true'>
.lightPoint {
  height: 554px;
  box-sizing: border-box;
  background: url(https://picbed.qunarzz.com/ed7d99966c9ed3b95f80b8eee88ea4c8.jpg)
    no-repeat;
  padding-top:60px;
  background-size: 100% auto;
  &-tit {
    padding-top: 10px;
    padding-bottom: 27px;
    padding-left: 91px;
    padding-right: 91px;
  }
  &-cont {
    width: calc(100% - 16px);
    margin-left: 8px;
    margin-right: 8px;
    height: 270px;
    img {
      position: relative;
      z-index: 2;
      display: block;
    }
    .img-box {
      position: relative;
      height:239px;
      overflow:hidden;
      img{
          position: absolute;
          bottom:0;
          left: 0;
      }
    }
  }
  .imgBg{
    margin-left:auto;
    margin-right:auto;
    box-sizing: border-box;
  }
  /deep/ .mint-swipe-indicator {
    width: 25px;
    height: 4px;
    border-radius: 2px;
    background-color: #cdcdcd;
    opacity: 1;
    transition: all ease 0.5s;
    &.is-active {
      width: 70px;
      background-color: #486278;
    }
  }
  /deep/ .mint-swipe-indicators {
    z-index: 20;
    width: 280px;
  }
  #station{
    height:535px;
    .line{
      position: relative;
      height:100px;
      overflow-x: hidden;
      width:calc(100% - 14px);
      margin-left:auto;
      margin-right:auto;
      .normal,.active{
        display: block;
        position: absolute;
        left:0;
        top:0;
        display: block;
      }
      .normal{
        height:100%;
        width:100%;
        position: relative;
      }
      .common{
        background:url(https://picbed.qunarzz.com/0070b5eb5a84dccd29313ac80cc3ce81.png) no-repeat;
        background-size:auto 100%;
        height:54px;
        position: absolute;
        left:0;
        top:46px;
        width:100%;
        overflow-x: hidden;
        &-active{
          z-index:2;
          background-image:url(https://picbed.qunarzz.com/0c819bea3d4c647e4b46959bc0f47ce0.png);
        }
      }
      .area{
        position: absolute;
        left:0;
        top:0;
        z-index:1;
        height:100%;
      }
      .area_ls{
        width:63px;
        left:40px;
      }
      .area_blc{
        left:103px;
        width:53px;
      }
      .area_lz{
        left:156px;
        width:65px;
      }
      .area_bm{
        left:221px;
        width:60px;
      }
      .area_bs{
        left:281px;
        width:40px;
      }
      .area_cd{
        left:321px;
        width:calc(100% - 321px);
      }
      .ls{
        .common{
          &-lf{
            width:42px;
          }
          &-active{
            left:42px;
            width:70px;
            background-position-x: -42px;
          }
          &-rt{
            width:calc(100% - 112px);
            background-position-x: -112px;
            left:112px;
          }
        }
      }
      .blc{
        .common{
          &-lf{
            width:84px;
          }
          &-active{
            left:84px;
            width:83px;
            background-position-x: -84px;
          }
          &-rt{
            width:calc(100% - 167px);
            background-position-x: -167px;
            left:167px;
          }
        }
      }
      .lz{
        .common{
          &-lf{
            width:143px;
          }
          &-active{
            left:143px;
            width:72px;
            background-position-x: -143px;
          }
          &-rt{
            width:calc(100% - 215px);
            background-position-x: -215px;
            left:215px;
          }
        }
      }
      .bm{
        .common{
          &-lf{
            width:202px;
          }
          &-active{
            left:202px;
            width:60px;
            background-position-x: -202px;
          }
          &-rt{
            width:calc(100% - 262px);
            background-position-x: -262px;
            left:262px;
          }
        }
      }
      .bs{
        .common{
          &-lf{
            width:262px;
          }
          &-active{
            left:262px;
            width:50px;
            background-position-x: -262px;
          }
          &-rt{
            width:calc(100% - 312px);
            background-position-x: -312px;
            left:312px;
          }
        }
      }
      .cd{
        .common{
          &-lf{
            width:304px;
          }
          &-active{
            left:304px;
            width:100%;
            background-position-x: -304px;
          }
          &-rt{
            width:0;
          }
        }
      }
    }
  }
}
.car{
  width:70px;
}
.desBg{
  padding-top:21px;
  img{
    width:300px;
  }
}
.car-txt{
  width:100px;
  position: absolute;
  left:0;
  top:-36px;
  height:36px;
  text-align: center;
  line-height: 30px;
  color:#17171A;
  font-weight: bold;
  .txt{
    position: relative;
    z-index:1;
    font-size:11px;
  }
  img{
    position: absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
  }
}
.carBox{
  position: absolute;
}
.carBox_ls{
  left:35px;
  bottom:35px;
}
.carBox_blc{
  left:89px;
  bottom:27px;
}
.carBox_lz{
  left:154px;
  bottom:27px;
}
.carBox_bm{
  left:213px;
  bottom:27px;
}
.carBox_bs{
  left:252px;
  bottom:27px;
}
.carBox_cd{
  left:298px;
  bottom:27px;
  .car-txt{
    left:-40px;
  }
}
</style>